import { z } from 'zod';
import { annotationStatusSchema } from '../../shared/models/annotationStatus.schema';

export const queueCountsSchema = z.record(annotationStatusSchema, z.number());
